import { Table, Badge } from "react-bootstrap";
import { getContrastColor } from "../../_helpers/contrast";

function PhaseTable({ phases, scoreVariant }) {
  return (
    <Table bordered hover className="mb-4" style={{ tableLayout: "fixed" }}>
      <thead>
        <tr>
          <th style={{ width: "40%" }}>Fase</th>
          <th style={{ width: "20%" }}>Voorkeur</th>
          <th>Opmerking</th>
        </tr>
      </thead>
      <tbody>
        {phases.map(({ phaseID, phaseName, trajectoryName, campusName, phaseColor, pref }) => {
          const contextLabel = [trajectoryName, campusName].filter(Boolean).join(" — ");
          const score = pref?.passionScore;
          return (
            <tr key={phaseID}>
              <td style={{ verticalAlign: "top" }}>
                {phaseColor ? (
                  <span style={{ backgroundColor: phaseColor, color: getContrastColor(phaseColor), padding: "2px 8px", borderRadius: 4, display: "inline-block" }}>
                    {phaseName || `Fase ${phaseID}`}
                  </span>
                ) : (phaseName || `Fase ${phaseID}`)}
                {contextLabel && <span className="text-muted ms-1">{contextLabel}</span>}
              </td>
              <td style={{ verticalAlign: "top" }}>
                {score === 0 ? (
                  <Badge bg="secondary">Geen voorkeur</Badge>
                ) : score != null ? (
                  <Badge bg={scoreVariant(score)}>{score}/10</Badge>
                ) : (
                  <span className="text-muted fst-italic">Niet ingevuld</span>
                )}
              </td>
              <td className="text-muted" style={{ verticalAlign: "top" }}>{pref?.comment || ""}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default PhaseTable;
